import { render, staticRenderFns } from "./AfficheFacture.vue?vue&type=template&id=422db349&scoped=true&"
import script from "./AfficheFacture.vue?vue&type=script&lang=js&"
export * from "./AfficheFacture.vue?vue&type=script&lang=js&"
import style0 from "./AfficheFacture.vue?vue&type=style&index=0&id=422db349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422db349",
  null
  
)

export default component.exports